import React from "react";
import type { Config as PuckConfig } from "@measured/puck";
import {
  MacroTextBlock,
  MacroHeadingBlock,
  MacroLinkBlock,
  MacroButtonLinkBlock,
  MacroConditionalBlock,
  MacroDividerBlock,
  MacroSignatureBlock,
  MacroMarkdownBlock,
  MacroHtmlBlock,
  MacroProgramsRepeaterBlock,
  MacroRoomsRepeaterBlock,
  MacroPosItemsRepeaterBlock,
} from "./blocks";

// Root props for macro templates
export interface MacroRootProps {
  name: string;
  slug: string;
  type: string;
  description: string;
}

// Macro types available
export const MACRO_TYPES = [
  { label: "Contact Form Quote", value: "ContactFormQuote" },
  { label: "Contact Form Auto Reply", value: "ContactFormAutoReply" },
  { label: "Booking Payment Request", value: "BookingPaymentRequest" },
  { label: "Booking Confirmation", value: "BookingConfirmation" },
  { label: "Payment Link", value: "PaymentLink" },
] as const;

export function getMacroPuckConfig(): PuckConfig {
  return {
    root: {
      fields: {
        name: {
          type: "text",
          label: "Macro Name",
        },
        slug: {
          type: "text",
          label: "Slug (unique identifier)",
        },
        type: {
          type: "select",
          label: "Type",
          options: MACRO_TYPES.map((t) => ({ label: t.label, value: t.value })),
        },
        description: {
          type: "textarea",
          label: "Description",
        },
      },
      defaultProps: {
        name: "New Macro",
        slug: "new-macro",
        type: "ContactFormQuote",
        description: "",
      },
      render: (props: any) => {
        const { children } = props;
        return (
          <div className="macro-content" style={{ fontFamily: "Arial, sans-serif", fontSize: "14px", lineHeight: "1.6" }}>
            {children}
          </div>
        );
      },
    },
    categories: {
      text: {
        title: "Text",
        components: ["Markdown", "Html", "Text", "Heading"],
      },
      links: {
        title: "Links & CTAs",
        components: ["Link", "ButtonLink"],
      },
      repeaters: {
        title: "Repeaters",
        components: ["ProgramsRepeater", "RoomsRepeater", "PosItemsRepeater"],
      },
      layout: {
        title: "Layout & Logic",
        components: ["Divider", "Conditional"],
      },
      presets: {
        title: "Presets",
        components: ["Signature"],
      },
    },
    components: {
      Markdown: MacroMarkdownBlock as any,
      Html: MacroHtmlBlock as any,
      Text: MacroTextBlock as any,
      Heading: MacroHeadingBlock as any,
      Link: MacroLinkBlock as any,
      ButtonLink: MacroButtonLinkBlock as any,
      Conditional: MacroConditionalBlock as any,
      Divider: MacroDividerBlock as any,
      Signature: MacroSignatureBlock as any,
      // Collection repeaters
      ProgramsRepeater: MacroProgramsRepeaterBlock as any,
      RoomsRepeater: MacroRoomsRepeaterBlock as any,
      PosItemsRepeater: MacroPosItemsRepeaterBlock as any,
    },
  };
}

// Export the config for use in editor and SSR
export const macroPuckConfig = getMacroPuckConfig();
